<div class="grid">
    <div class="col-12">
        <div class="flex flex-column gap-2">
            <div class="flex">
                <p-checkbox [(ngModel)]="membre.indChargeProjet" [binary]="true" inputId="chargeProjet"></p-checkbox>
                <div class="flex flex-column gap-2">
                    <label for="chargeProjet" class="ml-2">Chargé de projet</label>
                    <small class="ml-2">Le membre est chargé de projet sur le site. Permet de voir une vue filtrée dans les
                        commandes.</small>
                </div>
            </div>

            <div class="flex">
                <p-checkbox [(ngModel)]="membre.indResponsable" [binary]="true" inputId="responsable"></p-checkbox>
                <div class="flex flex-column gap-2">
                    <label for="responsable" class="ml-2">Responsable</label>
                    <small class="ml-2">Le membre est responsable du site.</small>
                </div>
            </div>

            <div class="flex align-items-center">
                <p-checkbox [(ngModel)]="membre.indReceptionRapportJournalier" [binary]="true"
                    inputId="rapportJournalier"></p-checkbox>
                <div class="flex flex-column gap-2">
                    <label for="rapportJournalier" class="ml-2">Réception de rapports journaliers</label>
                    <small class="ml-2">Le membre est dans la liste de destinataire des rapports journaliers SST pour ce site.</small>
                </div>
            </div>

            <div class="flex align-items-center">
                <p-checkbox [(ngModel)]="membre.indReceptionPriseHeures" [binary]="true"
                    inputId="priseHeures"></p-checkbox>
                <div class="flex flex-column gap-2">
                    <label for="priseHeures" class="ml-2">Réception de prise des heures/kms</label>
                    <small class="ml-2">Le membre reçoit le rapport de prise des heures/kms à remplir pour ce site toutes les
                        semaines.</small>
                </div>
            </div>

            <div class="flex align-items-center">
                <p-checkbox [(ngModel)]="membre.indReceptionEntreesSorties" [binary]="true"
                    inputId="receptionEntreesSorties"></p-checkbox>
                <div class="flex flex-column gap-2">
                    <label for="receptionEntreesSorties" class="ml-2">Réception du rapport entrées/sorties</label>
                    <small class="ml-2">Le membre reçoit le rapport hebdomadaire des entrées/sorties pour ce site.</small>
                </div>
            </div>

            <div class="flex">
                <p-checkbox [(ngModel)]="membre.indSst" [binary]="true" inputId="sst"></p-checkbox>
                <div class="flex flex-column gap-2">
                    <label for="sst" class="ml-2">Responsable SST</label>
                    <small class="ml-2">Le membre est responsable SST pour ce site. Permet de voir une vue filtrée dans les rapports
                        journaliers SST.</small>
                </div>
            </div>
        </div>
    </div>

    <div class="col-12 flex justify-content-end gap-2 mt-4">
        <button pButton pRipple label="Annuler" icon="pi pi-times" class="p-button-text" (click)="annuler()"></button>
        <button pButton pRipple label="Modifier" icon="pi pi-check" class="p-button-primary"
            (click)="modifier()"></button>
    </div>
</div>